var _rect, _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgPermPhoneMsg = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_616_658",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.00012207,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_616_658)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 13.0001V4.00012C12 3.71679 12.0958 3.47929 12.2875 3.28762C12.4792 3.09596 12.7167 3.00012 13 3.00012H20C20.2833 3.00012 20.5208 3.09596 20.7125 3.28762C20.9042 3.47929 21 3.71679 21 4.00012V9.00012C21 9.28346 20.9042 9.52096 20.7125 9.71262C20.5208 9.90429 20.2833 10.0001 20 10.0001H15L12 13.0001ZM14 8.00012H19V5.00012H14V8.00012ZM19.95 21.0001C17.8667 21.0001 15.8083 20.546 13.775 19.6376C11.7417 18.7293 9.89167 17.4418 8.225 15.7751C6.55833 14.1085 5.27083 12.2585 4.3625 10.2251C3.45417 8.19179 3 6.13346 3 4.05012C3 3.75012 3.1 3.50012 3.3 3.30012C3.5 3.10012 3.75 3.00012 4.05 3.00012H8.1C8.33333 3.00012 8.54167 3.07929 8.725 3.23762C8.90833 3.39596 9.01667 3.58346 9.05 3.80012L9.7 7.30012C9.73333 7.56679 9.725 7.79179 9.675 7.97512C9.625 8.15846 9.53333 8.31679 9.4 8.45012L6.975 10.9001C7.30833 11.5168 7.70417 12.1126 8.1625 12.6876C8.62083 13.2626 9.125 13.8168 9.675 14.3501C10.1917 14.8668 10.7333 15.346 11.3 15.7876C11.8667 16.2293 12.4667 16.6335 13.1 17.0001L15.45 14.6501C15.6 14.5001 15.7958 14.3876 16.0375 14.3126C16.2792 14.2376 16.5167 14.2168 16.75 14.2501L20.2 14.9501C20.4333 15.0168 20.625 15.1376 20.775 15.3126C20.925 15.4876 21 15.6835 21 15.9001V19.9501C21 20.2501 20.9 20.5001 20.7 20.7001C20.5 20.9001 20.25 21.0001 19.95 21.0001ZM6.025 9.00012L7.675 7.35012L7.25 5.00012H5.025C5.10833 5.68346 5.225 6.35846 5.375 7.02512C5.525 7.69179 5.74167 8.35012 6.025 9.00012ZM14.975 17.9501C15.625 18.2335 16.2875 18.4585 16.9625 18.6251C17.6375 18.7918 18.3167 18.9001 19 18.9501V16.7501L16.65 16.2751L14.975 17.9501Z",
    fill: "#757575"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPermPhoneMsg, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/perm_phone_msg.720ad7b4.svg";
export { ForwardRef as ReactComponent };